import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	FeaturedCoursesEmpty: {
		k: "featured.empty.title",
		v: "No Featured Courses Available"
	},

	DescriptionEmpty: {
		k: "featured.empty.description",
        v: ""
	},

	CoursePermissionDenied: {
		k: "featured.launch",
		v: "No permission to launch course"
	}
});



// WEBPACK FOOTER //
// ./src/panels/featured/Featured.labels.ts